import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';
import { getBrowserDetails } from 'utils/userAgentUtils';
import { connektApiKey, connektStageApiKey } from 'constants/AppConstants';

export const SAVE_WEBPUSH_TOKEN_REQUEST = 'SAVE_WEBPUSH_TOKEN_REQUEST';
export const SAVE_WEBPUSH_TOKEN_SUCCESS = 'SAVE_WEBPUSH_TOKEN_SUCCESS';
export const SAVE_WEBPUSH_TOKEN_ERROR = 'SAVE_WEBPUSH_TOKEN_ERROR';

export function saveWebpushTokenRequestAction() {
	return { type: SAVE_WEBPUSH_TOKEN_REQUEST };
}

export function saveWebpushTokenSuccessAction(data) {
	return { type: SAVE_WEBPUSH_TOKEN_SUCCESS, data };
}

export function saveWebpushTokenErrorAction(error) {
	return { type: SAVE_WEBPUSH_TOKEN_ERROR, error };
}

export function saveWebpushTokenAction(subscription) {
	return dispatch => {
		dispatch(saveWebpushTokenRequestAction());
		const browserDetails = getBrowserDetails();
		const payload = {
			brand: browserDetails && browserDetails.name,
			osVersion: browserDetails && browserDetails.version,
			appVersion: '1',
			state: 'order',
			token: subscription.endpoint,
			keys: subscription.toJSON().keys
		};
		const apiHeaders = Object.assign({}, headers, { apiKey: __DEBUG_ENV__ ? connektStageApiKey : connektApiKey });
		return ApiCaller.put(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/connekt/register/push`,
				headers: apiHeaders
			}),
			payload
		).then(
			json => dispatch(saveWebpushTokenSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(saveWebpushTokenErrorAction(err));
			}
		);
	};
}

export const saveNotificationPreferences = payload => {
	const { query = '' } = payload;
	return () => {
		return ApiCaller.put(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/2/communication/setPreferences${query}`
			}),
			payload
		);
	};
};

export const blockNotificationPreferences = () => {
	return () => {
		return ApiCaller.put(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/2/communication/block`
			}),
			{}
		);
	};
};
